var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup41(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.154541 2.34961L3.75126 0.722523C4.27525 0.485478 4.87593 0.485478 5.39993 0.722523L8.23187 2.00364C8.72105 2.22494 9.27867 2.24025 9.77926 2.04615L14.1545 0.349609",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.154541 2.34961L3.75126 0.722523C4.27525 0.485478 4.87593 0.485478 5.39993 0.722523L8.23187 2.00364C8.72105 2.22494 9.27867 2.24025 9.77926 2.04615L14.1545 0.349609",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.154541 6.34961L3.75126 4.72252C4.27525 4.48548 4.87593 4.48548 5.39993 4.72252L8.23187 6.00364C8.72105 6.22494 9.27867 6.24025 9.77926 6.04615L14.1545 4.34961",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.154541 6.34961L3.75126 4.72252C4.27525 4.48548 4.87593 4.48548 5.39993 4.72252L8.23187 6.00364C8.72105 6.22494 9.27867 6.24025 9.77926 6.04615L14.1545 4.34961",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.154541 10.3496L3.75126 8.72252C4.27525 8.48548 4.87593 8.48548 5.39993 8.72252L8.23187 10.0036C8.72105 10.2249 9.27867 10.2403 9.77926 10.0461L14.1545 8.34961",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.154541 10.3496L3.75126 8.72252C4.27525 8.48548 4.87593 8.48548 5.39993 8.72252L8.23187 10.0036C8.72105 10.2249 9.27867 10.2403 9.77926 10.0461L14.1545 8.34961",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup41);
export default __webpack_public_path__ + "static/media/Group 41.6c6bcf85b59658f1a4a1499318c8242b.svg";
export { ForwardRef as ReactComponent };